<script>

    import { CreditStore, InvoiceStore } from '../stores'

    import Modal from '../$components/modal.svelte'
    import Credits from '../credits/credits.svelte'
    import CreditRead from '../credits/credit.svelte'
    import CreditCreate from '../credits/credit.create.svelte'
    import CreditTransfers from '../credits/credit.tranfers.svelte'
    import InvoiceCreate from '../invoices/invoice.credit.create.svelte'

</script>

<Credits />

<Modal id="CreditRead" title="Información credito" >
    <CreditRead on:deleted={CreditStore.modalClose} />
</Modal>

<Modal id="CreditCreate" title="Agregar credito" >
    <CreditCreate on:created={CreditStore.modalClose} on:canceled={CreditStore.modalClose} />
</Modal>

<Modal id="InvoiceCreate" title="Solicitar factura" >
    <InvoiceCreate on:created={InvoiceStore.modalClose} on:canceled={InvoiceStore.modalClose} />
</Modal>

<Modal id="CreditTransfers" title="Transferencias" >
    <CreditTransfers on:created={InvoiceStore.modalClose} on:canceled={InvoiceStore.modalClose} />
</Modal>